// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__T0psY","section":"Footer_section__VNVEN","footer":"Footer_footer__kXlYa"};